export default __webpack_public_path__ + "static/media/photo.500c3d07.svg";